import { render } from "./WeddingDate.vue?vue&type=template&id=2c4bc443&scoped=true&ts=true"
import script from "./WeddingDate.vue?vue&type=script&lang=ts"
export * from "./WeddingDate.vue?vue&type=script&lang=ts"

import "./WeddingDate.vue?vue&type=style&index=0&id=2c4bc443&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4bc443"]])

export default __exports__